var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-loader-ac"},[_c('svg',{staticClass:"loader__spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"loader__spinner-path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }